import type { Tag } from "@/services/api/tags";
import type { TagSortDirection, TagSortField } from "./tagUtils";
import { TagsTableHeader } from "./TagsTableHeader";
import { TagsTableRow } from "./TagsTableRow";

interface TagsTableProps {
  tags: Tag[];
  sortField: TagSortField;
  sortDirection: TagSortDirection;
  onSort: (field: TagSortField) => void;
  onEdit: (tag: Tag) => void;
  onDelete: (tag: Tag) => void;
  onColorChange: (tag: Tag, color: string) => void;
}

export function TagsTable({
  tags,
  sortField,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
  onColorChange,
}: TagsTableProps) {
  if (tags.length === 0) {
    return (
      <div className="py-12 text-center text-sm text-ink-500">
        No tags found. Create your first tag to get started.
      </div>
    );
  }

  return (
    <div className="max-h-[70vh] overflow-auto pb-8">
      <table className="w-full">
        <TagsTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <tbody className="divide-y divide-grid-200">
          {tags.map((tag) => (
            <TagsTableRow
              key={String(tag.id)}
              tag={tag}
              onEdit={onEdit}
              onDelete={onDelete}
              onColorChange={onColorChange}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
